export default "__VITE_ASSET__0be1ec22__$_?component__"